const MODEL_SCORE_FIELDS = [
  'radarScore',
  'radarScoreLeft',
  'radarScoreRight',
  'radarThreshold',
  'predictionCorrect',
  'modelName'
];

export const mergeUpdatedWalk = (
  listedWalk,
  updatedWalk,
  annotationsChanged
) => {
  const merged = { ...listedWalk, ...updatedWalk };
  if (listedWalk.modelName !== updatedWalk.modelName) {
    MODEL_SCORE_FIELDS.forEach(field => {
      if (field in listedWalk) {
        merged[field] = listedWalk[field];
      }
    });
    if (annotationsChanged) {
      merged.predictionCorrect = null;
    }
  }
  if (typeof listedWalk.analysisIncluded !== 'boolean') {
    return merged;
  }
  if (updatedWalk.validationStatus !== 'SUSPECT') {
    merged.analysisIncluded = true;
  } else if (listedWalk.validationStatus !== 'SUSPECT') {
    merged.analysisIncluded = false;
  } else {
    merged.analysisIncluded = listedWalk.analysisIncluded;
  }
  return merged;
};
